import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Checkbox } from 'primereact/checkbox';
import { useMutation } from '@apollo/react-hooks';
import { injectIntl } from 'react-intl';
import { UPDATE_LOCAL_ARI } from '../mutations';
import messages from '../intl-messages';
import { withGrowl } from '../../../../components/GrowlNotifications';


const ManageMandatory = ({
  field, currentAccount, intl: { formatMessage }, growl,
}) => {
  const [updateLocalAri, updateLocalAriResult] = useMutation(UPDATE_LOCAL_ARI, { refetchQueries: ['getAccount'] });
  const [mandatory, setMandatory] = useState(null);

  useEffect(() => {
    setMandatory(field.mandatory);
  }, [field]);

  return (
    <>
      <div>
        <small>
          {formatMessage(messages.manageMandatoryLabel)}
        </small>
      </div>
      {
        updateLocalAriResult.loading ? (
          <div>
            <i className="pi pi-spin pi-spinner" />
          </div>
        ) : (
          <Checkbox
            disabled={updateLocalAriResult.loading}
            checked={mandatory}
            onChange={() => {
              const input = {
                accountId: currentAccount,
                ariFieldId: field.id,
                dataType: field.dataType,
                question: field.question,
                answers: field.answers,
                mandatory: !field.mandatory,
              };

              setMandatory(!mandatory);
              updateLocalAri({ variables: { input } })
                .then(() => {
                  growl.show({
                    severity: 'success',
                    sticky: false,
                    summary: formatMessage(messages.growlAddFieldSuccessSummary),
                    detail: formatMessage(messages.growlToggleMandatorySuccessDetail),
                  });
                })
                .catch(() => {
                  setMandatory(mandatory);
                  growl.show({
                    severity: 'error',
                    sticky: true,
                    summary: formatMessage(messages.growlAddFieldFailSummary),
                    detail: formatMessage(messages.growlToggleMandatoryFailDetail),
                  });
                });
            }}
          />
        )
      }
    </>
  );
};

ManageMandatory.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  growl: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default injectIntl(withGrowl(ManageMandatory));
